import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { BrowserRouter as Router, Route } from "react-router-dom";
import CreateDSTab from "./CreateDSTab"
import EncDecTab from "./EncDecTab"
import KeyGenerationTab from "./KeyGenerationTab"
import '../../css/sjwsa-client-kredobank.css'

class RoutedBody extends Component {

	componentDidMount() {
		
	}

	render() {
			return (
				<Router>
			      <div>
			      	<Route path="/" exact component={CreateDSTab} />
			        <Route path="/sjwsa-client-ds/" component={CreateDSTab} />
			        <Route path="/sjwsa-client-encdec/" component={EncDecTab} />
			        <Route path="/sjwsa-client-keygen/" component={KeyGenerationTab} />
			      </div>
			    </Router>
		    );
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        connectionStatus: state.connectionStatusReucer,
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutedBody);


// WEBPACK FOOTER //
// ./src/components/body/RoutedBody.js